import script from "./RankingView.vue?vue&type=script&setup=true&lang=ts"
export * from "./RankingView.vue?vue&type=script&setup=true&lang=ts"

import "./RankingView.vue?vue&type=style&index=0&id=22b614c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22b614c9"]])

export default __exports__